import { render, staticRenderFns } from "./NormConsumption.vue?vue&type=template&id=0071bdd9&lang=pug"
import script from "./NormConsumption.vue?vue&type=script&lang=js"
export * from "./NormConsumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports